export default function reducer(state, action) {
  switch (action.type) {
    case "SET_CANCEL_TOKEN":
      return {
        ...state,
        cancelToken: action.payload
      };
    default:
      return state;
  }
}
